export default "__VITE_ASSET__TZU5vaCq__"